import { render, staticRenderFns } from "./CustomQuestionAnswerMailingAddress.vue?vue&type=template&id=1cc58f77"
import script from "./CustomQuestionAnswerMailingAddress.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerMailingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports